const THRESHOLD = 4;

export const pathNeedsFormatting = (
  path: string,
  thresholdOverride?: number
) => {
  const threshold = thresholdOverride || THRESHOLD;
  return path.split("/").length > threshold;
};

export const formatFilePath = (path: string, thresholdOverride?: number) => {
  const pathParts = path.split("/");
  const threshold = thresholdOverride || THRESHOLD;
  if (pathParts.length <= threshold) {
    return path;
  } else {
    const firstPart = Array.from({ length: threshold - 1 }, (_, i) => i)
      .map((i) => pathParts[i])
      .join("/");
    const lastPart = pathParts[pathParts.length - 1];
    return `${firstPart}/.../${lastPart}`;
  }
};

export const fileName = (path: string) => {
  return path.split("/").pop() || "";
};
